import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { NavigationMenu } from '../../../admin/layout/left-sidebar/left-sidebar.models';
import { AuthService } from '../../services/authentication/auth.service';
import { PCodeUsersHub } from '../../services/hubs/pcode-users/pcode-users.hub';
import { RefreshTokenRequestResponse, AccessTokenResponse, AccessTokenRequest, AuthenticationProvidersResponse } from './login.models';

@Injectable()
export class LoginService
{
	// constructor
	constructor
		(
			private http: HttpClient,
			private router: Router,
			private pcodeUsersHub: PCodeUsersHub,
			@Inject('BASE_URL') private baseUrl: string
		)
	{

	}

	// access token
	accessToken(request: AccessTokenRequest): Observable<AccessTokenResponse>
	{
		this.logout(false);

		return this.http.post<AccessTokenResponse>(`${this.baseUrl}api/shared/auth/accessToken`, request);
	}

	// get pcode access token from Azure AD token
	accessTokenFromAzureAd(azureToken: string): Observable<AccessTokenResponse>
	{
		return this.http.post<AccessTokenResponse>(`${this.baseUrl}api/shared/auth/accessTokenFromAzureAd`, { azureToken: azureToken });
	}

	// refresh token
	refreshToken(request: RefreshTokenRequestResponse): Observable<RefreshTokenRequestResponse>
	{
		return this.http.post<RefreshTokenRequestResponse>(`${this.baseUrl}api/shared/auth/refreshToken`, request);
	}

	// logout
	logout(redirectToLogin = true)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/logout`, {}).subscribe(() =>
		{
			// removing access_token
			AuthService.removeAccessToken();
			AuthService.removeRefresToken();
			AuthService.removeAzureAdAccessToken();

			// disconnect from notifications hub
			this.pcodeUsersHub.disconnect();

			// redirect to login
			if (redirectToLogin)
				this.router.navigate(['login']);
		});
	}

	// forgot password
	forgotPassword(email: string)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/forgotPassword`, { email: email });
	}

	// reset password
	resetPassword(userId: string, token: string, newPassword: string)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/resetPassword`, { userId: userId, token: token, password: newPassword });
	}

	// reset password (internal)
	resetPasswordInternal(userId: string, newPassword: string)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/resetPasswordInternal`, { userId: userId, password: newPassword });
	}

	// get authentication providers
	getAuthenticationProviders(): Observable<AuthenticationProvidersResponse>
	{
		return this.http.get<AuthenticationProvidersResponse>(this.baseUrl + 'api/shared/auth/getAuthenticationProviders');
	}

	// get navigation menu
	getNavigationMenu()
	{
		return this.http.get<NavigationMenu>(this.baseUrl + 'api/shared/shared/getNavigationMenu');
	}
}